
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class EditMechanicalEmbroideryMaterialCompositionModal extends Vue {

    @Prop() availableMaterials: string[];
    @Prop() materialsPercentage: OM.KeyValuePairOfStringAndDouble[];
    @Prop() saveCallback: (materialsList: OM.KeyValuePairOfStringAndDouble[]) => void;

    localModel: OM.KeyValuePairOfStringAndDouble[] = [];
    disablePercentage: boolean = false;
    tempMaterialName: string = "";
    tempMaterialPercentage: number = 0;
    errorMessage: string = "";

    created() {
        this.materialsPercentage.forEach(element => {
            this.localModel.push(element);
        });
    }

    get filteredMaterials(){
        var modelMaterials = this.localModel.map( x => x.key);

        return this.availableMaterials.filter( x => {
            if(modelMaterials.indexOf(x) == -1)
                return x;
        })
    }

    get remainingPercentage(){
        const percentageTotal = this.localModel.reduce((sum, item) => {
            return sum + parseFloat(String(item.value || 0));
        }, 0);
        
        return 100 - percentageTotal;
    }

    get adddisabled(){
        return !this.tempMaterialName || !this.tempMaterialPercentage || this.remainingPercentage == 0;
    }

    addLayer(){
        if(this.remainingPercentage == 0)
            return;

        if(this.disablePercentage)
            this.tempMaterialPercentage = 100;
            
        var keyValue = new OM.KeyValuePairOfStringAndDouble();
        keyValue.key = this.tempMaterialName;
        keyValue.value = this.tempMaterialPercentage;
        this.localModel.push(keyValue);

        this.tempMaterialName = "";
        this.tempMaterialPercentage = 0;
    }

    removeMaterial(index: number){
        this.localModel.splice(index, 1);
    }
    
    get disabled() {
        return this.localModel.length == 0;
    }

    save() {
        if(this.remainingPercentage > 0)
            this.errorMessage = this.$localizationService.getLocalizedValue("Remaining percentage more than 0, please change your values", "Remaining percentage more than 0, please change your values");
        else
            this.saveCallback(this.localModel);
    }
}
